import moment from "moment";
import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import "react-quill/dist/quill.snow.css";
import DatePicker from "react-datepicker";
import { numberFormat, showMessage } from "../../Utils/comman";
import QRCode from "react-qr-code"; // import styles for the editor

function ViewInvoice(props) {
  const dispatch = useDispatch();
  const [orderId, setOrderId] = useState(0);
  const [formData, setFormData] = useState({
    orderId: orderId,
    invoiceDate: new Date(),
  });
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);
  const [piData, setPiData] = useState([]);
  const [response, setResponse] = useState([]);
  const [orderProducts, setOrderProducts] = useState([]);
  const [grandTotals, setGrandTotals] = useState({
    total_qty: 0,
    gross_amount: 0,
    trade_discount: 0,
    qty_discount: 0,
    cash_discount: 0,
    special_discount: 0,
    final_amount: 0,
    insurance_per: 0,
    insurance_amount: 0,
    freight_amount: 0,
    cgst: 0,
    sgst: 0,
    igst: 0,
    tcs_per: 0,
    tcs_amount: 0,
    round_off: 0,
    grand_total: 0,
  });

  useEffect(() => {
    setOrderId(
      props?.rowData?.orderdata && props?.rowData?.orderdata.id
        ? props?.rowData?.orderdata.id
        : props?.rowData?.id
    );
  }, []);

  useEffect(() => {
    if (orderId > 0) {
      getPiData();
    }
  }, [orderId]);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const getPiData = () => {
    utils
      .callAPI("get", `/sales/getInvoiceData?id=${orderId}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          const invoice_data = res?.invoice_data || {};
          let orderStatus = parseInt(invoice_data?.order_status);
          if (isNaN(orderStatus) && invoice_data?.order_data) {
            orderStatus = parseInt(invoice_data?.order_data?.order_status);
          }

          const products = [...invoice_data?.Proforma_invoice_products];
          products.map((product) => {
            product.size = (product.size * 1).toFixed(2);
            product.total_qty = (
              product.total_qty ? parseFloat(product.total_qty) : 0
            ).toFixed(2);
          });

          setFormData({ ...formData, orderId: orderId });
          setOrderProducts(products);
          setResponse(res);
          setGrandTotals(res?.invoice_data?.grand_totals);
          setPiData(res?.invoice_data);
        } else {
          setPiData([]);
        }
      })
      .catch((err) => {
        setPiData([]);
      });
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleDownload = () => {
    utils
      //.callAPI("get", `sales/download_invoice_main/${piData?.id}`)
      .callAPI("get", `sales/download_invoice_main/${orderId}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          // window.open(res, "_blank");
          const a = document.createElement("a");
          a.href = res;
          a.target = "_blank"; // or "_self" depending on your preference
          a.rel = "noopener noreferrer";
          a.click();
        } else {
          //setPiData([]);
        }
      })
      .catch((err) => {
        // setPiData([]);
      });
  };

  return (
    <div className="section-body ">
      <RB.Card className="">
        <RB.Card.Header>
          <h4>Invoice</h4>
          <div className="card-header-action">
            <RB.Button className="btn btn-light me-2" onClick={handleDownload}>
              Download
            </RB.Button>
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <div className={"pi-invoice"}>
            <RB.Row>
              <RB.Col md={9}>
                <RB.Row className={"border"}>
                  <RB.Col md={12} className={"py-2 text-center"}>
                    <h6 className={"mb-0"}>TAX INVOICE</h6>
                    <small>Issued under GST Invoice Rules</small>
                  </RB.Col>
                </RB.Row>

                <RB.Row className={"border border-top-0"}>
                  <RB.Col md={4} className={"border-end py-2"}>
                    <h6>
                      <strong>Supplier - Seller:</strong>
                    </h6>
                    <p className={"mb-0"}>
                      <strong>{piData.registered_office?.company_name}</strong>
                    </p>
                    <p className={"mb-0"}>
                      {piData.registered_office?.address}
                      <br />
                      {piData.registered_office?.city} -{" "}
                      {piData.registered_office?.pincode}
                    </p>
                    <p className={"mb-0"}>
                      <strong>State:</strong> {piData.registered_office?.state}
                    </p>
                    <RB.Row>
                      <RB.Col md={6}>
                        <strong>GSTIN:</strong>{" "}
                        {piData.registered_office?.gstno}
                      </RB.Col>
                      {/*<RB.Col md={6}>
                    <strong>PAN:</strong> AABCS4338M
                  </RB.Col>*/}
                    </RB.Row>

                    {/*<RB.Row>
                  <RB.Col md={6}>
                    <strong>CIN:</strong> U26109TN1997PL037875
                  </RB.Col>
                  <RB.Col md={6}>
                    <strong>TAN:</strong> CHES05530A
                  </RB.Col>
                </RB.Row>*/}
                  </RB.Col>
                  <RB.Col md={4} className={"border-end py-2"}>
                    <h6>
                      <strong>Recipient - Customer :</strong>
                    </h6>
                    <>
                      <p className={"mb-0"}>
                        <strong>{piData?.bill_to_data?.company_name}</strong>
                      </p>
                      <p className={"mb-0"}>
                        {piData?.bill_to_data?.company_address},<br />
                        {piData?.bill_to_data?.district},<br />
                        {piData?.bill_to_data?.city} -{" "}
                        {piData?.bill_to_data?.pincode},<br />
                        {/*Ph. : BILL TO PHONE<br/>*/}
                      </p>
                      <p className={"mb-0"}>
                        <strong>State:</strong> {piData?.bill_to_data?.state}
                      </p>
                      <p className={"mb-0"}>
                        <strong>GSTIN:</strong> {piData?.bill_to_data?.gst_no}
                      </p>
                    </>
                  </RB.Col>
                  <RB.Col md={4} className={"border1 py-2"}>
                    <p className={"mb-0"}>
                      <strong>Invoice No.: </strong> {response?.invoice_no}
                    </p>
                    <p className={"mb-0"}>
                      <strong>Invoice Date: </strong>{" "}
                      {response?.invoice_date
                        ? moment(response?.invoice_date).format("DD-MM-YYYY")
                        : ""}
                    </p>
                    <p className={"mb-0"}>
                      <strong>PI No.: </strong> {piData?.invoice_no}
                    </p>
                    <p className={"mb-0"}>
                      <strong>PI Date: </strong>{" "}
                      {moment(piData?.invoice_date).format("DD-MM-YYYY")}
                    </p>
                    <p className={"mb-0"}>
                      <strong>Sales Order No.: </strong>{" "}
                      {piData?.order_data?.order_id}
                    </p>
                    <p className={"mb-0"}>
                      <strong>Sales Order Date: </strong>{" "}
                      {moment(piData?.order_data?.order_date).format(
                        "DD-MM-YYYY"
                      )}
                    </p>
                    <p className={"mb-0"}>
                      <strong>Ref.: </strong> {piData?.emp_ref_no}
                    </p>
                    <p className={"mb-0"}>
                      <strong>IRN Ack.No.: </strong> {piData?.AckNo}
                    </p>
                    <p className={"mb-0"}>
                      <strong>IRN Ack.Date.: </strong>{" "}
                      {piData?.AckDt
                        ? moment(piData?.AckDt).format("DD-MM-YYYY")
                        : ""}
                    </p>
                    <p className={"mb-0"}>
                      <strong>EWB No.: </strong> {piData?.EwbNo}
                    </p>
                    <p className={"mb-0"}>
                      <strong>EWB Date: </strong>{" "}
                      {piData?.EwbDt
                        ? moment(piData?.EwbDt).format("DD-MM-YYYY")
                        : ""}
                    </p>
                  </RB.Col>
                </RB.Row>

                <RB.Row className={"border border-top-0 border-bottom-0"}>
                  <RB.Col md={4} className={"border-end py-2"}>
                    <h6>
                      <strong>Destination Center:</strong>
                    </h6>
                    <>
                      <p className={"mb-0"}>
                        <strong>{piData?.location_data?.name}</strong>
                      </p>
                      <p className={"mb-0"}>
                        {piData?.location_data?.address},<br />
                        {/*{piData?.location_data?.district},<br/>*/}
                        {piData?.location_data?.city} -{" "}
                        {piData.location_data?.pincode},<br />
                        {piData.location_data?.state}
                      </p>
                    </>
                  </RB.Col>
                  <RB.Col md={4} className={"border-end py-2"}>
                    <h6>
                      <strong>Ship - To :</strong>
                    </h6>
                    <>
                      <p className={"mb-0"}>
                        <strong>{piData?.ship_to_data?.company_name}</strong>
                      </p>
                      <p className={"mb-0"}>
                        {piData?.ship_to_data?.company_address},<br />
                        {piData?.ship_to_data?.city},<br />
                        {piData?.ship_to_data?.state} -{" "}
                        {piData?.ship_to_data?.pincode}
                      </p>
                    </>
                  </RB.Col>
                  <RB.Col md={4} className={"border1 py-2"}>
                    <h6>
                      <strong>Transport Details:</strong>
                    </h6>
                    <p className={"mb-0"}>
                      <strong>Transporter:</strong> {piData?.transporter_name}
                    </p>
                    <p className={"mb-0"}>
                      <strong>Destination:</strong> {piData?.destination}
                    </p>
                    <p className={"mb-0"}>
                      <strong>Vehicle No.:</strong> {piData?.motor_vehicle_no}
                    </p>
                    <p className={"mb-0"}>
                      <strong>Driver Name:</strong> {piData?.driver_name}
                    </p>
                    <p className={"mb-0"}>
                      <strong>Driver Mobile No.:</strong>{" "}
                      {piData?.driver_mobile_no}
                    </p>
                    <p className={"mb-0"}>
                      <strong>Bill of Lading/LR-RR No.:</strong>{" "}
                      {piData?.bill_of_landing_lr_rr_no}
                    </p>
                  </RB.Col>
                </RB.Row>
              </RB.Col>
              <RB.Col md={3}>
                <div className={"w-100 text-center"}>
                  ORIGINAL FOR RECIPIENT
                </div>
                {piData?.qrimg && (
                  <div
                    className={
                      "text-center d-flex align-items-center justify-content-center p-3 h-100"
                    }
                  >
                    <QRCode
                      style={{
                        height: "auto",
                        maxWidth: "100%",
                        width: "100%",
                      }}
                      value={piData?.qrimg}
                      viewBox={`0 0 256 256`}
                    />
                  </div>
                )}
              </RB.Col>
            </RB.Row>
            <RB.Row className={"border border-top-0 border-bottom-0"}>
              <RB.Col md={3} className={"border-end py-2"}></RB.Col>
              <RB.Col md={3} className={"border-end py-2"}></RB.Col>
              <RB.Col md={6} className={"border-end-0 border-top py-2"}>
                <p className={"mb-0"}>
                  <strong>IRN:</strong> {piData?.Irn}
                </p>
              </RB.Col>
            </RB.Row>
            <RB.Row className={"border border-bottom-0"}>
              <h5 className="mt-3">Products</h5>

              <div className={"table-responsive p-0 border"}>
                <RB.Table
                  bordered
                  hover
                  striped
                  className="border mb-0 table-sm table-invoice-products"
                >
                  <thead>
                    <tr>
                      <th rowSpan={2}>S.No</th>
                      <th rowSpan={2}>Description of Goods</th>
                      <th className={"text-center"} rowSpan={2}>
                        UOM
                      </th>
                      <th className={"text-center"} rowSpan={2}>
                        HSN
                      </th>
                      <th className={"text-center"}>CGST</th>
                      <th className={"text-center"}>SGST</th>
                      <th className={"text-center"}>IGST</th>
                      <th className={"text-center"} rowSpan={2}>
                        Rate / UOM
                      </th>
                      <th colSpan={3} className={"text-center"}>
                        Quantity
                      </th>
                      <th className={"text-center"} rowSpan={2}>
                        Gross Value
                      </th>
                      <th className={"text-center"} colSpan={4}>
                        Discounts
                      </th>
                      <th className={"text-center"} rowSpan={2}>
                        Net Value
                      </th>
                    </tr>
                    <tr>
                      <th className={"text-center"}>%</th>
                      <th className={"text-center"}>%</th>
                      <th className={"text-center"}>%</th>
                      <th className={"text-center"}>In UOM</th>
                      <th className={"text-center"}>Pack Size</th>
                      <th className={"text-center"}>Total Qty(Kg)</th>
                      <th className={"text-center"}>Trade (%)</th>
                      <th className={"text-center"}>Quantity (%)</th>
                      <th className={"text-center"}>Cash (%)</th>
                      <th className={"text-center"}>Special (%)</th>
                    </tr>
                  </thead>

                  <tbody>
                    {orderProducts.length &&
                      orderProducts.map((product, index) => (
                        <tr key={index}>
                          <td className={"text-center"}>{index + 1}</td>
                          <td>{product.product_name}</td>
                          <td className={"text-center"}>
                            {(product.mou || "").toUpperCase()}
                          </td>
                          <td className={"text-center"}>
                            {product.hsn_code || ""}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product?.gst?.cgst?.per || 0).toFixed(
                              2
                            )}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product?.gst?.sgst?.per || 0).toFixed(
                              2
                            )}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product?.gst?.igst?.per || 0).toFixed(
                              2
                            )}
                          </td>
                          <td className={"text-end"}>
                            {numberFormat(product.rate)}
                          </td>
                          <td className={"text-end"}>{product.actual_qty}</td>
                          <td className={"text-end"}>
                            {parseFloat(product.size).toFixed(2)}
                          </td>
                          <td className={"text-end"}>{product.total_qty}</td>
                          <td className={"text-end"}>
                            {numberFormat(product.gross_amount)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(
                              product?.discounts?.trade?.per || 0
                            ).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(
                              product?.discounts?.qty?.per || 0
                            ).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(
                              product?.discounts?.cash?.per || 0
                            ).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(
                              product?.special?.qty?.per || 0
                            ).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {numberFormat(product.row_amount)}
                          </td>
                        </tr>
                      ))}
                  </tbody>

                  <tfoot>
                    <tr>
                      <th colSpan={9}></th>
                      <th className={"text-end"}>Total</th>
                      <th className={"text-end"}>
                        {parseFloat(grandTotals?.total_qty).toFixed(2)}
                      </th>
                      <th className={"text-end"}>
                        {numberFormat(grandTotals?.gross_amount)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(grandTotals?.trade_discount)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(grandTotals?.qty_discount)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(grandTotals?.cash_discount)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(grandTotals?.special_discount)}
                      </th>
                      <th className={"text-end"}>
                        {numberFormat(grandTotals?.final_amount)}
                      </th>
                    </tr>
                  </tfoot>
                </RB.Table>
              </div>
            </RB.Row>

            <RB.Row>
              <RB.Col
                md={8}
                className={"border border-top-0 order-sm-1 order-md-1 order-2"}
              >
                <RB.Row className={"border-bottom py-1"}>
                  <RB.Col>
                    <strong>Total in Words: {piData?.grand_total_word}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom py-1"}>
                  <RB.Col className={"small"}>
                    {piData?.terms_condition?.line1}
                  </RB.Col>
                </RB.Row>

                <RB.Row className={"border-bottom py-2"}>
                  <RB.Col>
                    <p
                      className="mb-0"
                      dangerouslySetInnerHTML={{
                        __html: piData?.terms_condition?.line2,
                      }}
                    ></p>
                  </RB.Col>
                </RB.Row>

                <RB.Row className={"py-1"}>
                  <RB.Col>
                    <strong>Terms and Conditions</strong>
                    <p className={"mb-1"} style={{ lineHeight: "normal" }}>
                      <small>{piData?.terms_condition?.line3}</small>
                    </p>

                    {piData?.delivery_terms
                      ? piData?.delivery_terms
                          .split("\n")
                          .map(function (item, idx) {
                            return (
                              <p
                                className={"small mb-1"}
                                style={{ lineHeight: "normal" }}
                                key={idx}
                              >
                                {item}
                              </p>
                            );
                          })
                      : " "}
                  </RB.Col>
                </RB.Row>
              </RB.Col>
              <RB.Col md={4} className={"border order-md-2 order-sm-2 order-1"}>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    Net Amount
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(grandTotals?.final_amount)}</strong>
                  </RB.Col>
                </RB.Row>

                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    Insurance{" "}
                    {grandTotals?.insurance_per > 0
                      ? `(${grandTotals?.insurance_per}%)`
                      : ""}
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>
                      {numberFormat(
                        grandTotals?.insurance_amount > 0
                          ? grandTotals?.insurance_amount
                          : 0
                      )}
                    </strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    Freight Amount (₹)
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>
                      {numberFormat(
                        grandTotals?.freight_amount > 0
                          ? grandTotals?.freight_amount
                          : 0
                      )}
                    </strong>
                  </RB.Col>
                </RB.Row>

                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    CGST
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(grandTotals?.cgst)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    SGST
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(grandTotals?.sgst)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    IGST
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(grandTotals?.igst)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    TCS{" "}
                    {grandTotals?.tcs_per ? `(${grandTotals?.tcs_per} %)` : ""}
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(grandTotals?.tcs_amount)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    Round Off
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(grandTotals?.round_off)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center bg-light"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    <strong>Invoice Total</strong>
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(grandTotals?.grand_total)}</strong>
                  </RB.Col>
                </RB.Row>
              </RB.Col>
            </RB.Row>
          </div>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default ViewInvoice;
